import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { IEndpointData } from 'SharedDir/declarations/shared';

export const projectDescriptionUrl = `${SERVER_API}/project-descriptions`;

export const ADMINISTRATION_PROJECT_DESCRIPTION = {
  GET: {
    method: 'GET',
    url: `${projectDescriptionUrl}`,
  } as IEndpointData,
};
